/* eslint-disable camelcase */
import axios from '../axios'
import configuration from '../configurations'
import i18n from '../i18n'
import { AES } from 'crypto-js'

const defaultData = {
  type: 'trading_license',
  status: 'submitted',
  timestamp: new Date().toISOString(),
  applicant: {
    name: '',
    identity_type: '',
    identity_no: '',
    phone: '',
    email: '',
    address: ''
  },
  business: {
    business_name: '',
    address: '',
    phone: '',
    fax: '',
    business_location: '',
    business_activity: [],
    premise: true,
    assessment_no: '',
    state: 'SABAH'
  },
  council_license: [],
  owner: {},
  _attachments: {},
  manager: {
    name: '',
    identity_type: '',
    identity_no: '',
    date_of_birth: '',
    work_pass: '',
    expired_date_of_pass: '',
    citizenship: '',
    gender: '',
    religion: '',
    race: '',
    bumiputera_status: '',
    residential_address: '',
    mailing_address: '',
    state: '',
    mobile_tel: '',
    office_tel: '',
    residential_tel: '',
    nationality: 'MALAYSIAN'
  }
}

const form = {
  namespaced: true,
  state: {
    council: 'mpt',
    data: Object.assign({}, defaultData),
    error: null,
    id: null,
    loading: false,
    trca: [],
    trcc: [],
    trcs: []
  },
  getters: {
    isLoading: function (state, getters, rootState, rootGetters) {
      return state.loading
    }
  },
  mutations: {
    setError: function (state, payload = { error: null }) {
      state.error = payload.error
    },
    setLoading: function (state, payload = { loading: false }) {
      state.loading = payload.loading
    },
    setData: function (state, payload = { data: defaultData }) {
      state.data = payload.data
    },
    resetData: function (state) {
      state.data = Object.assign({}, defaultData)
    },
    patchApplicant: function (state, { applicant }) {
      state.data.applicant = Object.assign({}, state.data.applicant, applicant)
    },
    patchBusiness: function (state, { business }) {
      state.data.business = Object.assign({}, state.data.business, business)
    },
    patchBusinessActivity: function (state, { business_activity }) {
      if (state.data.business.business_activity.indexOf(business_activity) === -1) {
        state.data.business.business_activity.push(business_activity)
      }
    },
    removeBusinessActivity: function (state, { business_activity }) {
      for (var i = 0; i < state.data.business.business_activity.length; i++) {
        if (state.data.business.business_activity[i] === business_activity) {
          state.data.business.business_activity.splice(i, 1)
        }
      }
    },
    patchCouncilLicense: function (state, { council_license, index }) {
      state.data.council_license[index] = Object.assign({}, state.data.council_license[index], council_license)
    },
    patchOwner: function (state, { owner }) {
      state.data.owner = Object.assign({}, state.data.owner, owner)
    },
    patchManager: function (state, { manager }) {
      state.data.manager = Object.assign({}, state.data.manager, manager)
      delete state.data.manager.ownership_type
    },
    resetOwner: function (state) {
      state.data.owner = Object.assign({}, defaultData.owner)
    },
    resetManager: function (state) {
      state.data.manager = Object.assign({}, defaultData.manager)
    },
    setItems: (state, payload) => (state[payload.prefix] = payload.data)
  },
  actions: {
    fetchData: async function (context, payload) {
      const blobToBase64 = blob => new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(blob)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
      context.commit('setLoading', { loading: true })
      try {
        const response = await axios.post(`/query`, { url: btoa(`apply_trading/${payload.id}`)
        })
        let file
        let i
        let attachment = []
        for (i = 0; i < 5; i++) {
          if (i === 0) file = 'photocopy_ic'
          if (i === 1) file = 'sales_purchase_agreement'
          if (i === 2) file = 'photocopy_submit_plan_receipt'
          if (i === 3) file = 'photocopy_health_card'
          if (i === 4) file = 'photocopy_food_handling_certificate'
          const res = await axios.get(`/getAttachments/apply_trading/${payload.id}/${file}`, {
            responseType: 'arraybuffer'
          })
          const blob = new Blob([res.data], {
            type: 'application/pdf'
          })
          attachment.push({ name: file, dataurl: await blobToBase64(blob) })
        }
        response.data._attachments = attachment
        context.commit('setData', { data: response.data })
        context.commit('setError', { error: null })
      } catch (error) {
        context.commit('setError', { error })
        this.dispatch('snackbar/setSnackBar', {
          color: 'error',
          message: i18n.t('fetching_data_failed'),
          visible: true
        })
        throw error
      } finally {
        context.commit('setLoading', { loading: false })
      }
    },
    onBusinessCategoryChanged: async function (context, payload) {
      context.commit('setLoading', { loading: true })
      try {
        let currentBookmark = null
        let data = []
        const operation = async (prefix, index) => {
          const query = {
            selector: {
              subcategory_id: {
                $eq: payload
              },
              status: {
                $eq: 'active'
              }
            },
            limit: 100,
            use_index: index
          }
          if (currentBookmark) query.bookmark = currentBookmark
          const { data: response } = await axios.post(`/licenses/license_trading/find`, query)
          const { bookmark, docs } = response
          if (docs.length > 0) {
            currentBookmark = bookmark
            data = data.concat(docs)
            await operation(prefix, index)
          }
        }
        await operation('code-activities', 'indexes/activities')
        context.commit('setItems', { prefix: 'trca', data })
        data = []
        context.commit('setError', { error: null })
        return data
      } catch (error) {
        context.commit('setError', { error })
        this.dispatch('snackbar/setSnackBar', {
          color: 'error',
          message: i18n.t('fetching_data_failed'),
          visible: true
        })
        throw error
      } finally {
        context.commit('setLoading', { loading: false })
      }
    },
    fetchActivities: async function (context, payload) {
      context.commit('setLoading', { loading: true })
      console.log('QUERY: ACTIVITIES START')
      try {
        let currentBookmark = null
        let data = []
        const operation = async (type, index) => {
          const query = {
            selector: {
              status: {
                $eq: 'active'
              },
              type: {
                $eq: type
              }
            },
            limit: 100,
            use_index: index
          }
          if (currentBookmark) query.bookmark = currentBookmark
          const { data: response } = await axios.post(`/licenses/license_trading/find`, query)
          const { bookmark, docs } = response
          if (docs.length > 0) {
            currentBookmark = bookmark
            data = data.concat(docs)
            await operation(type, index)
          }
        }
        await operation('code-category', 'indexes/category')
        context.commit('setItems', { prefix: 'trcc', data })
        data = []
        currentBookmark = null
        await operation('code-subcategory', 'indexes/subcategory')
        context.commit('setItems', { prefix: 'trcs', data })
        data = []
        currentBookmark = null
        context.commit('setError', { error: null })
        return data
      } catch (error) {
        context.commit('setError', { error })
        this.dispatch('snackbar/setSnackBar', {
          color: 'error',
          message: i18n.t('fetching_data_failed'),
          visible: true
        })
        throw error
      } finally {
        context.commit('setLoading', { loading: false })
        console.log('QUERY: ACTIVITIES END')
      }
    },
    async searchData (context, payload) {
      context.commit('setLoading', { loading: true })

      let databaseType = 'assessment'
      let council = context.state.council
      let query = { data: { _id: btoa(payload), council, payment_type: databaseType } }
      let apiUrl = `/search`

      try {
        const response = await axios.post(apiUrl, query)
        if (response.data) {
          if (Object.keys(response.data).length > 0) {
            context.commit('patchBusiness', {
              business: {
                title_no: response.data.current_title,
                payment_needed: response.data.arrears_only / 100,
                area: response.data.locality,
                use_code: '-',
                no_of_trading_on_property: '-',
                installment: false
              }
            })
            context.commit('setError', { error: null })
          }
        } else {
          this.dispatch('snackbar/setSnackBar', {
            color: 'error',
            message: 'Tidak jumpa rekod premise',
            visible: true
          })
        }
        return response.data
      } catch (error) {
        this.dispatch('snackbar/setSnackBar', {
          color: 'error',
          message: 'Tidak jumpa rekod premise',
          visible: true
        })
        context.commit('setError', { error })
        return error
      } finally {
        context.commit('setLoading', { loading: false })
      }
    },
    resetData: async function (context, payload = {}) {
      context.commit('setData', { data: defaultData })
    },
    sendSMS: async function (context, payload) {
      try {
        const body = {
          channel: 'sms',
          recipient: payload.contact,
          message: payload.message,
          subject: 'MPT'
        }
        const key = configuration.AES_SECRET
        const ciphertext = AES.encrypt(JSON.stringify(body), key).toString()
        console.log(AES.decrypt(JSON.stringify(body), key).toString())
        await axios.post('/api/notify', { message: btoa(ciphertext) }, {
          baseURL: 'https://sms.menggaris.com',
          withCredentials: false
        })
        if (payload.notify) {
          this.dispatch('snackbar/setSnackBar', {color: 'success', message: i18n.t('sms_sent'), visible: true})
        }
      } catch (error) {
        this.dispatch('snackbar/setSnackBar', {color: 'error', message: 'Failed to send sms verification', visible: true})
      }
    },
    submitData: async function (context, payload = defaultData) {
      context.commit('setLoading', { loading: true })

      try {
        payload._id = new Date().getTime().toString()
        let response = await axios.post(`/query`, { url: btoa('/apply_trading'), payload })

        context.commit('setData', { data: defaultData })
        context.commit('setError', { error: null })
        this.dispatch('snackbar/setSnackBar', {
          color: 'success',
          message: i18n.t('application_submitted'),
          visible: true
        })

        return response.data
      } catch (error) {
        context.commit('setError', { error })
        if (error.response.data.error === 'conflict') {
          this.dispatch('snackbar/setSnackBar', {
            color: 'error',
            message: i18n.t('email_already_exist'),
            visible: true
          })
        } else {
          this.dispatch('snackbar/setSnackBar', {
            color: 'error',
            message: i18n.t('attempt_failed_please_try_again'),
            visible: true
          })
        }
        throw error
      } finally {
        context.commit('setLoading', { loading: false })
      }
    }
  }
}

export default form
